<div class="question-linkage-container">
    <div class="logic-flow-generator">
        <div class="panel-group smart-accordion-default">
            <div class="table-responsive">
                <table class="table responsive"
                    *ngIf="interaction.sub_questions && interaction.sub_questions.length > 0">
                    <thead>
                        <tr>
                            <th class="col col-md-4 col-lg-4">Options Names</th>
                            <th class="col col-md-8 col-lg-8">Parent Linkage</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="initializedParentChild">
                        <ng-container *ngFor="let link of interaction.sub_questions; let i = index">
                            <tr *ngIf="!link.is_option_hidden">
                                <td class="col col-md-4 col-lg-4">
                                    <div class="option-names ltms-setup-condition-option-container" [title]="link.text">
                                        <!-- <i class="fa fa-sort vertical-center interaction-studio-sort-icon"></i> -->
                                        <span style="font-weight: bold;"></span> {{link.text}}
                                    </div>
                                </td>
                                <td class="col col-md-8 col-lg-8">
                                    <div class="form-group">
                                        <div class="input-group">
                                           <div style="width: calc(100% - 65px);min-width: calc(100% - 65px);">
                                            <app-litmus-multiselect-dropdown [options]="multiSelectData" [(ngModel)]="multiSelectModel[link.field_id]" (change)="onItemSelect($event,link)" [settings]="dropdownSettings" [disabled]="readOnly"></app-litmus-multiselect-dropdown>
                                           </div>

                                            <span class="input-group-btn">
                                                <button type="button" class="btn btn-default btn-parent-child"
                                                    [disabled]="readOnly" (click)="removeParentLinkage(link)">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
                <div style="text-align: center; padding: 20px 0px 25px;"
                    *ngIf="!interaction.sub_questions || interaction.sub_questions.length === 0">
                    No sub question found!
                </div>
            </div>
        </div>
    </div>
</div>